module.exports = __webpack_public_path__ + "img/logo.b8a657b1.png";